import React, { Component } from 'react';
import { Input, Tooltip, Button, Card, Tabs, Row, Col, Dropdown, Icon, Menu, Collapse, Form, Select, Radio, DatePicker, Spin, message, Modal } from 'antd';
import { compose } from 'recompose';
import * as actions from '../../actions/index';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import moment from 'moment';
import './profile.css';
import Skeleton from 'react-loading-skeleton';
import InputMask from 'react-input-mask'
import { each } from 'lodash';

const LoadingIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />;
const Panel = Collapse.Panel;
const FormItem = Form.Item;
const RadioGroup = Radio.Group;
const { Option } = Select;

const radioStyle = {
    display: 'block',
    height: '30px',
    lineHeight: '30px',
};

class AlumniInfoForm extends Component {
    constructor(props) {
        super(props)
        this.state = {
            forceRender: true,
            isInEditMode: false,
            firstName: '',
            middleName: '',
            lastName: '',
            nickName: '',
            dateOfBirth: '',
            gender: '',
            personGUID: '',
            IsFutureDate: false,
            CustomDateErrMsg: '',
            ethnicity: {},
        }

    }

    handleButtonClick(e) {
        console.log('click left button', e);
    }

    renderGender = () => {
        if (this.props.genders) {
            let gendersarray = this.props.genders
            return gendersarray.map((k, index) => {
                return (
                    <Radio value={k.short}>{k.name}</Radio>
                )
            })
        }
    }

    renderEthnicity = () => {
        if (this.props.ethnicities && Array.isArray(this.props.ethnicities) && this.props.ethnicities.length > 0 && !this.props.ethnicities_loading) {
            return this.props.ethnicities.map(ethnicity => <Option key={ethnicity.id} value={ethnicity.short}>{ethnicity.name}</Option>)
        } 
    }

    renderprefix = () => {
        if (this.props.prefixes) {
            let prefixesarray = this.props.prefixes
            return prefixesarray.map((k, index) => {
                return (
                    <option key={index + 1} value={k.name}>{k.name}</option>
                )
            })
        }
    }

    rendersuffix = () => {
        if (this.props.suffixes) {
            let suffixesarray = this.props.suffixes
            return suffixesarray.map((k, index) => {
                return (
                    <option key={index + 1} value={k.name}>{k.name}</option>
                )
            })
        }
    }

    componentDidMount = () => {
        this.props.actions.getEthnicities()
        this.props.actions.getGender()
        this.props.actions.getMaritalstatuses()
        this.props.actions.getPrefix()
        this.props.actions.getSuffix()
        this.props.actions.getOccupations()
    }

    CheckTheDate = (value, i) => {

        console.log("CheckTheDate " + value)
        var today = moment().format('MM/DD/YYYY'),
            enteredDate = value.split("/");

        enteredDate = new Date(enteredDate[2], enteredDate[1] - 1, enteredDate[0]).getTime();
        let isFuturedate = moment().isBefore(value);
        let isCurrentDate = moment(today).isSame(value);

        if (isFuturedate) {
            return this.setState({
                IsFutureDate: true,
                CustomDateErrMsg: 'The date Should not be in the future!'
            })
        }
        if (isCurrentDate) {
            return this.setState({
                IsFutureDate: true,
                CustomDateErrMsg: 'Date Of Birth should not be as a current Date!'
            })
        }
        else {
            return this.setState({
                IsFutureDate: false,
                CustomDateErrMsg: ''
            })
        }

    }

    renderCurrentAge = (dob) => {
        if (!dob) return '';
        const birthDate = moment(dob, ['YYYY-MM-DD', 'MM/DD/YYYY'], true);
        if (!birthDate.isValid()) return '';
        return moment().diff(birthDate, 'years');
    }

     handleSubmit = e => {
        e.preventDefault();
        if (!this.state.IsFutureDate) {
            this.props.form.validateFieldsAndScroll((err, values) => {
                if (!err) {
                    const { ethnicity } = this.state
                    const { suffixes, prefixes, ethnicities } = this.props
                    let suffix = suffixes.filter((data) => data.name == values.suffix)
                    let prefix = prefixes.filter((data) => data.name == values.prefix)
                    let suffixvalues = suffix.length ? parseInt(suffix[0].id) : ""
                    let prefixvalues = prefix.length ? parseInt(prefix[0].id) : ""
                    values.suffix = suffixvalues
                    values.prefix = prefixvalues

                    if (values.ethnicity) {
                        // let hasEthnicity  = this.props.profileinfo.extendedProfile.find(attr => attr.attributeId == '1')
                        if (ethnicity && (values.ethnicity != ethnicity.attributeVal) && ethnicities) {
                        values.ethnicity = ethnicities.find(each => each.short == values.ethnicity)
                        values.ethnicity.extendedProfileId = ethnicity.extendedProfileId
                    }}
            
                    this.props.actions.UpdateAlumniInfo(values, this.state.personGUID, 'alumni')
                }
            })
        }
    }

    cancelActions = () => {
        let loggedinUser = JSON.parse(localStorage.getItem('user'))
        let personGUID = loggedinUser.personGuid;
        this.props.actions.getProfileInfo(personGUID)
        this.setState({
            CustomDateErrMsg: undefined,
            IsFutureDate: false
        })
    }

    renderEditValues = (profileinfo) => {
        const Option = Select.Option;
        const FormItem = Form.Item;
        const dateFormat = 'YYYY/MM/DD';
        const { firstName } = this.state;
        if (this.state.personGUID == '') {
            this.setState({
                personGUID: profileinfo.profile.personGuid
            })
        }
        let phone = profileinfo.phones.length > 0 ? profileinfo.phones.filter((data) => JSON.parse(data.isPrimary.toLowerCase()))[0] : ''
        let email = profileinfo.emails.length > 0 ? profileinfo.emails.filter((data) => JSON.parse(data.isPrimary.toLowerCase()))[0] : ''
        let hobby, ethinic, maritalstatus, privacysettings = ''
        if (profileinfo.extendedProfile) {
            profileinfo.extendedProfile.filter((data) => {
                if (data.attributeId == 1) {
                    ethinic = data.attributeVal
                }
                if (data.attributeId == 5) {
                    maritalstatus = data.attributeVal
                }
                if (data.attributeId == 16) {
                    hobby = data.attributeVal
                }
                if (data.attributeId == 17) {
                    privacysettings = data.attributeVal
                }
            })
        }
        const { getFieldDecorator, getFieldValue } = this.props.form;
        getFieldDecorator('phonekeys', { initialValue: [] });
        return (

            <div className='edit-mode my-profile alumni-ui'>
                <Form onSubmit={this.handleSubmit} className="alumni-info-form">
                    <Row type='flex' justify='start'>
                        <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                            <Row type='flex' align='middle'>
                                <FormItem>
                                    <label className='field-label'> MY SCOUTING ID </label>
                                    <label className='my-profile-field-value'> {profileinfo && profileinfo.profile && profileinfo.profile.memberId ? profileinfo.profile.memberId : ''} </label>
                                </FormItem>
                            </Row>
                        </Col>
                    </Row>
                    <Row type='flex' justify='start'>
                        <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                            <FormItem hasFeedback
                                label={
                                    <span>
                                        First Name&nbsp;
                                        <Tooltip title="if you feel there is a discrepancy, please contact your local council">
                                            <Icon type="question-circle-o" />
                                        </Tooltip>
                                    </span>
                                }
                            >
                                {getFieldDecorator('firstname', {
                                    initialValue: profileinfo ? profileinfo.profile.firstName : "",
                                    rules: [{ required: true, message: 'Enter your First Name!' }],
                                })(
                                    <Input className='prefix'
                                        addonBefore={
                                            getFieldDecorator('prefix', {
                                                initialValue: profileinfo ? profileinfo.profile.title : "",
                                                rules: [{ required: false, message: 'Enter your Suffix!' }],
                                            })(
                                                <Select style={{ width: 70 }}>
                                                    <option key="0" value=""> - </option>
                                                    {this.renderprefix()}
                                                </Select>
                                            )
                                        } placeholder="First Name" disabled={!this.props.isSuperAlumniAdmin} name="firstname" />
                                )}
                            </FormItem>
                        </Col>
                        <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                            <FormItem hasFeedback
                                label={
                                    <span>
                                        Middle Name&nbsp;
                                        <Tooltip title="if you feel there is a discrepancy, please contact your local council">
                                            <Icon type="question-circle-o" />
                                        </Tooltip>
                                    </span>
                                }
                            >
                                {getFieldDecorator('middlename', {
                                    initialValue: profileinfo ? profileinfo.profile.middleName : "",
                                    rules: [{ required: false, message: 'Enter your Middle Name!' }],
                                })(
                                    <Input placeholder="Middle Name" disabled={!this.props.isSuperAlumniAdmin} name="middlename" />
                                )}
                            </FormItem>
                        </Col>
                        <Col xs={24} sm={24} md={8} lg={8} xl={8}>
                            <FormItem
                                label={
                                    <span>
                                        Last Name&nbsp;
                                        <Tooltip title="if you feel there is a discrepancy, please contact your local council">
                                            <Icon type="question-circle-o" />
                                        </Tooltip>
                                    </span>
                                }
                            >
                                {getFieldDecorator('lastname', {
                                    initialValue: profileinfo ? profileinfo.profile.lastName : "",
                                    rules: [{ required: true, message: 'Enter your Last Name!' }],
                                })(
                                    <Input className='suffix' addonAfter={
                                        getFieldDecorator('suffix', {
                                            initialValue: profileinfo ? profileinfo.profile.nameSuffix : "",
                                            rules: [{ required: false, message: 'Enter your Suffix!' }],
                                        })(
                                            <Select style={{ width: 70 }}>
                                                <option key="0" value=""> - </option>
                                                {this.rendersuffix()}
                                            </Select>
                                        )
                                    } placeholder="Last Name" disabled={!this.props.isSuperAlumniAdmin} name="lastname" />
                                )}
                            </FormItem>
                        </Col>
                        <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                            <FormItem hasFeedback
                                label="Nickname"
                            >
                                {getFieldDecorator('nickname', {
                                    initialValue: profileinfo ? profileinfo.profile.nickName : "",
                                    rules: [
                                        { required: false, message: 'Enter your NickName!' },
                                        { max: 50, message: 'Nickname must be maximum 50 characters.' },
                                    ],
                                })(
                                    <Input placeholder="NickName" name="nickname" />
                                )}
                            </FormItem>
                        </Col>
                        <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                            <FormItem hasFeedback
                                label={
                                    <span>
                                        Name displayed on Certificate&nbsp;
                                        <Tooltip title="if you feel there is a discrepancy, please contact your local council">
                                            <Icon type="question-circle-o" />
                                        </Tooltip>
                                    </span>
                                }
                            >
                                {getFieldDecorator('certificatename', {
                                    initialValue: profileinfo ? profileinfo.profile.certificateName : "",
                                    rules: [
                                        { required: false, message: '' },
                                        { max: 50, message: 'Certificate name must be maximum 50 characters.' },
                                    ],
                                })(
                                    <Input placeholder="Certificate Name" disabled />
                                )}
                            </FormItem>
                        </Col>
                        <Col xs={24} sm={24} md={6} lg={6} xl={6}>
                            <FormItem
                                hasFeedback
                                validateStatus={this.state.IsFutureDate ? "error" : undefined}
                                help={this.state.CustomDateErrMsg ? this.state.CustomDateErrMsg : undefined}
                                onBlur={(e) => this.CheckTheDate(e.target.value, 1)}
                                label={
                                    <span>
                                        Date of Birth&nbsp;
                                        <Tooltip title="if you feel there is a discrepancy, please contact your local council">
                                            <Icon type="question-circle-o" />
                                        </Tooltip>
                                    </span>
                                }
                            >
                                {getFieldDecorator('dob', {
                                    initialValue: profileinfo ? moment(profileinfo.profile.dateOfBirth).format('MM/DD/YYYY') : "",
                                    rules: [
                                        { required: true, message: 'Enter your Date of Birth!' },
                                        {
                                            pattern: /^(0[1-9]|1[0-2])\/(0[1-9]|1\d|2\d|3[01])\/(19|20)\d{2}$/,
                                            message: `Please enter correct format MM/DD/YYYY Pattern`
                                        }
                                    ],
                                })(
                                    // <Input disabled placeholder="Date Of Birth" disabled />
                                    <InputMask
                                        mask="99/99/9999"
                                        // disabled
                                        placeholder='MM/DD/YYYY'
                                        alwaysShowMask
                                        maskChar={null}
                                        className={
                                        !this.props.isSuperAlumniAdmin
                                            ? "ant-input width-100 disabled-input"
                                            : "ant-input width-100"
                                        }
                                        // className="ant-input width-100"
                                        disabled={!this.props.isSuperAlumniAdmin}
                                        render={(ref, props) => (
                                            <Input style={
                                                !this.props.isSuperAlumniAdmin
                                                    ? { backgroundColor: '#f5f5f5', color: 'rgba(0,0,0,0.45)' }
                                                    : {}
                                                }
                                            />
                                        )}
                                    />

                                )}
                            </FormItem>
                        </Col>     

                        <Col xs={24} sm={24} md={4} lg={4} xl={4}>
                            <FormItem label={<span>Current Age&nbsp;</span>}>
                                <Input
                                    value={
                                        this.props.profileinfo && this.props.profileinfo.profile.dateOfBirth
                                            ? this.renderCurrentAge(this.props.profileinfo.profile.dateOfBirth)
                                            : "-"
                                    }
                                    disabled
                            />
                            </FormItem>
                        </Col>     
                        
                        <Col xs={24} sm={24} md={5} lg={5} xl={5}>
                            <FormItem
                                label={
                                    <span>
                                        Gender&nbsp;
                                        <Tooltip title="if you feel there is a discrepancy, please contact your local council">
                                            <Icon type="question-circle-o" />
                                        </Tooltip>
                                    </span>
                                }
                            >
                                {getFieldDecorator('gender', {
                                    initialValue: profileinfo ? profileinfo.profile.gender : "",
                                    rules: [{ required: true, message: 'Enter your Gender!' }],
                                })(
                                    <RadioGroup disabled onChange={this.onChange} value={this.state.value}>
                                        {this.renderGender()}
                                    </RadioGroup>
                                )}
                            </FormItem>
                        </Col>

                        <Col xs={24} sm={24} md={9} lg={9} xl={9}>
                            <FormItem hasFeedback
                                label="Ethnicity"
                            >
                                {getFieldDecorator('ethnicity', {
                                    initialValue: this.state.ethnicity ? this.state.ethnicity.attributeVal : "",
                                    rules: [{ required: false, message: 'Enter Alumni\'s Ethnicity!' }],
                                })(
                                    <Select
                                        onChange={this.handleEthnicityChange}
                                        showSearch
                                        style={{ width: '100%' }}
                                        placeholder="Select an Ethnicity"
                                        optionFilterProp="children"
                                        filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                    >
                                        {this.renderEthnicity()}
                                    </Select>
                                )}
                            </FormItem>
                        </Col>
                    </Row>

                    <Row type='flex' className='btn-action' justify='space-around'>
                        <Col xs={23} sm={23} md={18} lg={18} xl={18}>
                            <Row type='flex' justify='space-around'>
                                <Col xs={24} sm={24} md={9} lg={9} xl={9}>
                                    <FormItem>
                                        <Button id="myprofile-info-cl-btn" className="myprofile-info-cl-btn myprofile-cancel-btn" onClick={() => this.cancelActions()}>CANCEL</Button>
                                    </FormItem>
                                </Col>
                                <Col xs={24} sm={24} md={9} lg={9} xl={9}>
                                    <FormItem>
                                        <Button id="myprofile-info-sb-btn" className="myprofile-info-sb-btn save-change-btn" style={{ margin: '0px', height: '56px' }} htmlType="submit" type="primary">SAVE CHANGES</Button>
                                    </FormItem>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Form>
            </div>
        )
    }

    renderEditView = () => {
        if (this.props.updating) {
            return (<Spin indicator={LoadingIcon} className="loading-state" style={{ height: 420 }} tip="Updating Information..." />)
        }
        else if (this.props.loading) {
            return (<Spin indicator={LoadingIcon} className="loading-state" style={{ height: 420 }} tip="Loading Information..." />)
        }
        else if (this.props.profileinfo) {
            return this.renderEditValues(this.props.profileinfo)
        }
        else {
            return (<Spin indicator={LoadingIcon} className="loading-state" tip="Loading Information..." />)
        }
    }

    componentWillReceiveProps = (nextprops) => {
        if (nextprops.profileinfo && nextprops.profileinfo.profile.personGuid == this.state.personGUID && nextprops.profileinfo.extendedProfile && nextprops.profileinfo.extendedProfile.length > 0) {
            let hasEthnicity = nextprops.profileinfo.extendedProfile.find(attr => attr.attributeId == '1')
            if (hasEthnicity) {
                this.setState({
                    ethnicity: hasEthnicity
                })
            }
        }
    }

    render() {
        return (
            <div className='personal-info-profile'>
                <div className='container'>
                    <div className='widget-content'>
                        <Row type="flex" justify="space-between">
                            <div className='widget-header-text'>
                                My Personal Information
                            </div>
                            <div className='widget-header-tool'>
                                {/* <label className='pointer' onClick={this.showModal} > Add New </label> */}
                            </div>
                        </Row>
                        <Row className='widget-content-section' type="flex" justify="center" align="middle">
                            {this.renderEditView()}
                        </Row>
                    </div>
                </div>
            </div>
        )
    }
}


function mapStateToProps(state) {
    return {
        loading: state.profilereducer.loading,
        profileinfo: state.profilereducer.profileinfo,
        countries: state.countriesreducer.countries,
        ethnicities_loading: state.ethnicitiesreducer.loading,
        ethnicities: state.ethnicitiesreducer.ethnicities,
        statuses: state.maritalstatusreducer.status,
        genders: state.gendersreducers.genders,
        suffixes: state.suffixreducers.suffixes,
        prefixes: state.prefixreducers.prefixes,
        updating: state.alumniinforamtionreducer.loading,
        occupationLoading: state.occupationsreducer.loading,
        occupations: state.occupationsreducer.occupations,
        isSuperAlumniAdmin: state.isadminreducer.isSuperAlumniAdmin,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(actions, dispatch)
    }
}
const AlumniInfo = Form.create()(AlumniInfoForm);
export default compose(connect(mapStateToProps, mapDispatchToProps), withRouter)(AlumniInfo);



// WEBPACK FOOTER //
// ./src/components/MyProfile/AlumniInfo.js